import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  SimpleChanges,
  OnChanges,
  OnDestroy
} from '@angular/core';
import * as moment from 'moment';
import { WindowsService } from '../shared/services/windows.service';

const SECOND = 1000;

@Component({
  selector: 'pbg-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  endTime: number;
  @Input()
  timeLimit = 2 * 60 * SECOND;
  @Output()
  timerChange: EventEmitter<any> = new EventEmitter();

  duration: any;
  currentTime: number;
  diffTime: number;
  interval = SECOND;
  timer: any;
  timerLabel: string;
  timerStatus = {
    started: false,
    ended: false,
    isShown: false
  };
  showTimer = false;

  constructor(public windowService: WindowsService) {}

  ngOnInit() {
    this.initializeAndStart();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.endTime) {
      this.endTime = changes.endTime.currentValue;
      this.initializeAndStart();
    }

    if (changes.timeLimit) {
      this.timeLimit = changes.timeLimit.currentValue;
      this.initializeAndStart();
    }
  }

  ngOnDestroy() {
    this.clean();
  }

  initializeAndStart() {
    this.initializeState();
    this.clean();
    this.startTimer();
  }

  initializeState() {
    this.timerStatus = {
      started: false,
      ended: false,
      isShown: false
    };
  }

  clean() {
    this.stopTimer();
  }

  startTimer() {
    this.currentTime = moment()
      .utc()
      .valueOf();

    this.diffTime = this.endTime - this.currentTime;
    this.duration = moment.duration(this.diffTime, 'milliseconds');

    this.timerStatus.started = true;
    this.timerStatus.ended = false;
    this.timerStatus.isShown = this.diffTime > 0;
    this.timerChange.emit({ status: this.timerStatus });

    this.timer = this.windowService.setInterval(() => {
      this.timerIntervalChangeHandler();
    }, SECOND);
  }

  timerIntervalChangeHandler() {
    this.duration = moment.duration(this.duration - this.interval, 'milliseconds');

    this.showTimer = this.duration - this.interval <= this.timeLimit;

    const minutes = this.duration.minutes();
    const seconds = this.duration.seconds();

    this.timerLabel = minutes + ':';
    if (minutes <= 0) {
      this.timerLabel = '';
    }

    if (seconds < 10) {
      this.timerLabel += '0' + seconds;
    } else {
      this.timerLabel += seconds;
    }

    if (minutes <= 0 && seconds <= 0) {
      this.timerLabel = 'Times Up!';
      this.timerStatus.ended = true;
      this.timerStatus.isShown = false;
      this.stopTimer();
    }
  }

  stopTimer() {
    this.timerChange.emit({ status: this.timerStatus, timeLeft: this.getTimeLeft() });
    this.initializeState();

    if (this.timer) {
      this.windowService.clearInterval(this.timer);
    }
  }

  getTimeLeft(): number {
    const timeLeft = Math.floor((this.duration - this.interval) / 1000);
    return timeLeft && (!isNaN(timeLeft) && timeLeft > 0) ? timeLeft : 0;
  }
}
